<template>
  <div class="customer-comment-wrapper mt-2 mb-7">
    <h2 class="pretopia-head-font mb-5 pb-2 border-bottom">{{ $t('components.common.wordFromOurCustomers') }}</h2>
    <transition name="custcomment" mode="out-in">
      <customer-comment-item-component image="ida_meyenberg.jpg" key="1" v-if="currentIndex === 1">
        "<span v-html="$t('home.customerQuotes.meyenberg.quote')"></span>"
        <template v-slot:name>Ida Meyenberg Hall</template>
        <template v-slot:title>{{ $t('home.customerQuotes.meyenberg.title') }}</template>
        <template v-slot:company>Meyenberg</template>
      </customer-comment-item-component>

      <customer-comment-item-component image="caroline_miljogarden.jpg" key="2" v-if="currentIndex === 2">
        "<span v-html="$t('home.customerQuotes.miljogarden.quote')"></span>"
        <template v-slot:name>Caroline Hjort</template>
        <template v-slot:title>{{ $t('home.customerQuotes.miljogarden.title') }}</template>
        <template v-slot:company>Miljögården.com</template>
      </customer-comment-item-component>

      <customer-comment-item-component image="asa_habo_gruppen.jpg" key="3" v-if="currentIndex === 3">
        "<span v-html="$t('home.customerQuotes.haboGruppen.quote')"></span>"
        <template v-slot:name>Åsa Karlsson</template>
        <template v-slot:title>{{ $t('home.customerQuotes.haboGruppen.title') }}</template>
        <template v-slot:company>Habo Gruppen AB</template>
      </customer-comment-item-component>

      <customer-comment-item-component
        image="Anders_Nilsson_Scandinavisk_Spismiljo.jpg"
        key="4"
        v-if="currentIndex === 4"
      >
        "<span v-html="$t('home.customerQuotes.scandinaviskSpismiljo.quote')"></span>"
        <template v-slot:name>Anders Nilsson</template>
        <template v-slot:title>{{ $t('home.customerQuotes.scandinaviskSpismiljo.title') }}</template>
        <template v-slot:company>Scandinavisk Spismiljö</template>
      </customer-comment-item-component>

      <customer-comment-item-component image="Sandra_Hemberg_Beslag_Design.jpg" key="5" v-if="currentIndex === 5">
        "<span v-html="$t('home.customerQuotes.beslagDesign.quote')"></span>"
        <template v-slot:name>Sandra Hemberg</template>
        <template v-slot:title>{{ $t('home.customerQuotes.beslagDesign.title') }}</template>
        <template v-slot:company>Beslag Design</template>
      </customer-comment-item-component>

      <customer-comment-item-component image="Linda_Fernell_Sweef_Furniture.jpg" key="6" v-if="currentIndex === 6">
        "<span v-html="$t('home.customerQuotes.sweefFurniture.quote')"></span>"
        <template v-slot:name>Linda Fernell</template>
        <template v-slot:title>{{ $t('home.customerQuotes.sweefFurniture.title') }}</template>
        <template v-slot:company>Sweef Furniture</template>
      </customer-comment-item-component>

      <customer-comment-item-component image="anne_almedahls_home.jpg" key="7" v-if="currentIndex === 7">
        "<span v-html="$t('home.customerQuotes.almedahlsHome.quote')"></span>"
        <template v-slot:name>Anne Skaug Andersson</template>
        <template v-slot:title>{{ $t('home.customerQuotes.almedahlsHome.title') }}</template>
        <template v-slot:company>Almedahls Home</template>
      </customer-comment-item-component>

      <customer-comment-item-component image="Anna_Benson.jpg" key="8" v-if="currentIndex === 8">
        "<span v-html="$t('home.customerQuotes.byBenson.quote')"></span>"
        <template v-slot:name>Anna Benson</template>
        <template v-slot:title>{{ $t('home.customerQuotes.byBenson.title') }}</template>
        <template v-slot:company>by Benson</template>
      </customer-comment-item-component>

      <customer-comment-item-component image="Catrin_Idyllien.jpg" key="9" v-if="currentIndex === 9">
        "<span v-html="$t('home.customerQuotes.idyllien.quote')"></span>"
        <template v-slot:name>Catrin Kylberg</template>
        <template v-slot:title>{{ $t('home.customerQuotes.idyllien.title') }}</template>
        <template v-slot:company>Idyllien</template>
      </customer-comment-item-component>

      <customer-comment-item-component image="malin_pot_paws.jpg" key="10" v-if="currentIndex === 10">
        "<span v-html="$t('home.customerQuotes.potPaws.quote')"></span>"
        <template v-slot:name>Malin Carrick</template>
        <template v-slot:title>{{ $t('home.customerQuotes.potPaws.title') }}</template>
        <template v-slot:company>POT PAWS</template>
      </customer-comment-item-component>

      <customer-comment-item-component image="jennie_himlekok.jpg" key="11" v-if="currentIndex === 11">
        "<span v-html="$t('home.customerQuotes.himlekok.quote')"></span>"
        <template v-slot:name>Jennie Ullman</template>
        <template v-slot:title>{{ $t('home.customerQuotes.himlekok.title') }}</template>
        <template v-slot:company>Himlekök</template>
      </customer-comment-item-component>

      <customer-comment-item-component image="elin_anebyhusgruppen.jpg" key="12" v-if="currentIndex === 12">
        "<span v-html="$t('home.customerQuotes.anebyhusgruppen.quote')"></span>"
        <template v-slot:name>Elin Ivarsson</template>
        <template v-slot:title>{{ $t('home.customerQuotes.anebyhusgruppen.title') }}</template>
        <template v-slot:company>Anebyhusgruppen</template>
      </customer-comment-item-component>

      <customer-comment-item-component image="jenny_ira_mobel.jpg" key="13" v-if="currentIndex === 13">
        "<span v-html="$t('home.customerQuotes.ireMobelAB.quote')"></span>"
        <template v-slot:name>Jenny Swärd</template>
        <template v-slot:title>{{ $t('home.customerQuotes.ireMobelAB.title') }}</template>
        <template v-slot:company>Ire Möbel AB</template>
      </customer-comment-item-component>

      <customer-comment-item-component image="patrik_dcor.jpg" key="14" v-if="currentIndex === 14">
        "<span v-html="$t('home.customerQuotes.dCor.quote')"></span>"
        <template v-slot:name>Patrik</template>
        <template v-slot:title>{{ $t('home.customerQuotes.dCor.title') }}</template>
        <template v-slot:company>D-cor.se</template>
      </customer-comment-item-component>
    </transition>
  </div>
</template>

<script>
import CustomerCommentItemComponent from './CustomerCommentItemComponent.vue';
export default {
  components: {
    CustomerCommentItemComponent,
  },
  data: function () {
    return {
      numberOfComments: 14,
      currentIndex: 1,
    };
  },
  mounted() {
    setInterval(() => {
      this.currentIndex = (this.currentIndex % this.numberOfComments) + 1;
    }, 10000);
  },
};
</script>

<style>
.custcomment-enter-active,
.custcomment-leave-active {
  transition-duration: 1s;
  transition-property: height, opacity, transform;
  /*transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
    overflow: hidden; */
}

.custcomment-enter {
  opacity: 0;
  transform: translate(2em, 0);
}

.custcomment-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}
</style>
